module.exports = __webpack_public_path__ + "91e5a9db570c74085484af45cc769f13.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-back/sp-back.html
// module id = 1094
// module chunks = 0